'use client';

import { ComponentProps } from 'react';
import { FloatingTree } from '@floating-ui/react';

export default function FloatingTreeProvider({ children }: ComponentProps<any>) {
    return (
        <FloatingTree>
                {children}
        </FloatingTree>
    );
}
